import { render, staticRenderFns } from "./science.vue?vue&type=template&id=5b8e6808&scoped=true"
import script from "./science.vue?vue&type=script&lang=js"
export * from "./science.vue?vue&type=script&lang=js"
import style0 from "./science.vue?vue&type=style&index=0&id=5b8e6808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e6808",
  null
  
)

export default component.exports